import React from 'react';
import styled from 'styled-components';
import useT from '@tools/ui-hooks/useT';
import { theme } from '@tools/ui-utils/theme.util';
import { isEmpty } from '@tools/ui-utils/values.util';

const ColoredSpan = styled.span`
  color: ${({ color }: { color: string }) => color};
  font-weight: 300;
`;

export enum NotAvailableEnum {
  Empty = 'EMPTY',
  NotAvailable = 'NA',
  Dash = 'DASH'
}

type IProps = {
  value?: unknown;
  notAvailableValueType?: NotAvailableEnum;
  'data-testid'?: string;
};

const DisplayValueIfExist: React.FC<React.PropsWithChildren<IProps>> = ({
  value,
  children,
  notAvailableValueType = NotAvailableEnum.NotAvailable,
  'data-testid': dataTestId
}) => {
  const { t } = useT();

  const NotAvailableValues = {
    [NotAvailableEnum.Empty]: <></>,
    [NotAvailableEnum.NotAvailable]: t('N/A'),
    [NotAvailableEnum.Dash]: '-'
  };

  return isEmpty(value) ? (
    <ColoredSpan
      color={theme.colors.value.notAvailable}
      data-testid={dataTestId}
    >
      {NotAvailableValues[notAvailableValueType]}
    </ColoredSpan>
  ) : (
    (children as React.ReactElement) ?? <>{value}</>
  );
};

export default DisplayValueIfExist;
